// 导入 抽取的 请求对象
import ajaxRequest from '../utils/request';
const reFix = 'productadmin';

// 抽取的接口方法
// 获取列表
export function houseList(params) {
  // console.log('参数：', params);
  // let lastParams = params.isExport ? params : { ...params, areaId };
  return ajaxRequest({
    url: reFix + '/House',
    method: 'GET',
    params,
  });
}
// 获取楼盘下拉列表
export function houseDropList(params) {
  return ajaxRequest({
    url: reFix + '/House/houseDropList',
    method: 'GET',
    params,
  });
}

// 获取单个楼盘
export function houseGetModel(id) {
  return ajaxRequest({
    url: reFix + '/House/' + id,
    method: 'GET',
  });
}

// 添加楼盘
export function houseAdd(data) {
  return ajaxRequest({
    url: reFix + '/House/Post',
    method: 'POST',
    data,
  });
}

// 更新楼盘
export function houseEdit(id, data) {
  return ajaxRequest({
    url: reFix + '/House/' + id,
    method: 'PUT',
    data,
  });
}

// 删除楼盘
export function houseRemove(id) {
  return ajaxRequest({
    url: reFix + '/House/' + id,
    method: 'DELETE',
  });
}

// 设置楼盘
export function houseChange(type, data) {
  return ajaxRequest({
    url: reFix + '/House/' + type,
    method: 'PUT',
    data,
  });
}

// 上传图片
export function houseUpload(data) {
  return ajaxRequest({
    url: 'upload/Images/upload',
    method: 'POST',
    data,
  });
}

// 获取楼盘描述
export function houseGetDescription(id) {
  return ajaxRequest({
    url: reFix + '/House/description/' + id,
    method: 'GET',
  });
}

// 更新楼盘描述
export function houseDescriptionEdit(id, data) {
  return ajaxRequest({
    url: reFix + '/House/description/' + id,
    method: 'PUT',
    data,
  });
}

// 获取楼盘佣金
export function houseGetRate(id) {
  return ajaxRequest({
    url: reFix + '/House/rate/' + id,
    method: 'GET',
  });
}

// 获取楼盘佣金-替换接口
export function rateByHouseRateIdApi(params) {
  return ajaxRequest({
    url: reFix + '/House/rateByHouseRateId',
    method: 'GET',
    params,
  });
}

// 更新楼盘佣金
export function houseRateEdit(id, data) {
  return ajaxRequest({
    url: reFix + '/House/rate/' + id,
    method: 'PUT',
    data,
  });
}

// 更新设置有效期的计算方式
// export function setValidityPeriod(data){
//     return ajaxRequest({
//         url:reFix + "/House/UpdateCalculateType",
//         method:'PUT',
//         data
//     })
// }
export function setValidityPeriod(data) {
  return ajaxRequest({
    url: reFix + '/House/UpdateCalculateType?' + data,
    method: 'PUT',
  });
}

// 更新固定佣金或者点数
export function updateBouns(data) {
  return ajaxRequest({
    url: reFix + '/House/updateBouns',
    method: 'PUT',
    data,
  });
}

// 获取楼盘分组图片
export function houseGetGroups(id) {
  return ajaxRequest({
    url: reFix + '/House/groups/' + id,
    method: 'GET',
  });
}

// 更新楼盘分组图片
export function houseGroupEdit(id, data) {
  return ajaxRequest({
    url: reFix + '/House/groups/' + id,
    method: 'PUT',
    data,
  });
}

// 获取所有楼盘编码
export function getAllBuildingCodesApi() {
  return ajaxRequest({
    url: reFix + '/House/GetFaceHouseCode',
    method: 'GET',
  });
}

// 微楼书上传地址：/upload/File/uploadFile
// 请求方法：POST

// 微楼书字段：HouseH5 --> HousePdf

export function uploadH5FileApi(data) {
  return ajaxRequest({
    url: '/upload/File/uploadFile',
    method: 'POST',
    data,
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 1、获取佣金列表
export function getCommisionListApi(params) {
  return ajaxRequest({
    url: reFix + '/House/HouseRatePages',
    method: 'GET',
    params,
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 2、获取历史佣金列表
export function getCommisionRecordApi(params) {
  return ajaxRequest({
    url: reFix + '/House/HouseRateHistoryPages',
    method: 'GET',
    params,
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 3、新增设置有效期的计算方式
export function addCommisionApi(data) {
  return ajaxRequest({
    url: reFix + '/House/InsertCalculateType',
    method: 'POST',
    data,
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 4、更新设置有效期的计算方式
export function updateCommisionApi(data) {
  return ajaxRequest({
    url: reFix + '/House/UpdateCalculateType',
    method: 'PUT',
    data,
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}
export function uploadExcelFileApi(data) {
  return ajaxRequest({
    url: reFix + '/House/upload_house',
    method: 'POST',
    data,
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}
